<form class="form-vertical" [formGroup]="tieredPriceForm">
  <div class="form-row row">
    <div class="form-group">
      <label for="amountOfMinutes" class="control-label required">{{'i18n.domain.administration.tariff-details.price-tab.amount-of-minutes' | translate}}</label>
      <ejs-numerictextbox format='n' decimals="0" formControlName="amountOfMinutes" name='amountOfMinutes' validateDecimalOnType="true" min="1"></ejs-numerictextbox>
      <app-error-messages [control]="formFields?.amountOfMinutes" [showUntouchedErrors]="!isAdd"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group">
      <label for="pricePerHour" class="control-label required">{{'i18n.domain.administration.tariff-details.price-tab.price-hour' | translate}}</label>
      <ejs-numerictextbox format='n2' decimals="2" formControlName="pricePerHour" name='pricePerHour' validateDecimalOnType="true" min="0"></ejs-numerictextbox>
      <app-error-messages [control]="formFields?.pricePerHour" [showUntouchedErrors]="!isAdd"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group">
      <label for="minStepInMinutes" class="control-label required">{{'i18n.domain.administration.tariff-details.price-tab.minStepInMinutes' | translate}}</label>
      <ejs-numerictextbox format='n' decimals="0" formControlName="minStepInMinutes" name='minStepInMinutes' validateDecimalOnType="true" min="1"></ejs-numerictextbox>
      <app-error-messages [control]="formFields?.minStepInMinutes" [showUntouchedErrors]="!isAdd"></app-error-messages>
      <small class="text-warning" *ngIf="isMultipleOfLinearPriceStep()">
        {{'i18n.domain.administration.tariff-details.price-tab.not-integer-divider-of-tiered-size' | translate}}
      </small>
    </div>
  </div>
</form>
